module.exports = __webpack_public_path__ + "img/Business Person 4.80c5b6c0.jpg";